import type { NotificationBroadcastObservationTransitionPayload } from "../notification-broadcast.type";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import {
  isNotificationBroadcastNamedModel,
  isValidNotificationBroadcastBase,
} from "../notification-broadcast.helper";

export const isNotificationBroadcastObservationTransitionPayload = (
  payload: unknown
): payload is NotificationBroadcastObservationTransitionPayload =>
  isValidNotificationBroadcastBase(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.OBSERVATION_TRANSITION &&
  "observations" in payload &&
  Array.isArray(payload.observations) &&
  payload.observations.length > 0 &&
  payload.observations.every(isNotificationBroadcastNamedModel) &&
  "user" in payload &&
  isNotificationBroadcastNamedModel(payload.user) &&
  "state" in payload &&
  typeof payload.state === "string";
